"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const extension_1 = require("../extension");
const sandbox_1 = require("../token-parser/sandbox");
const sandbox_2 = require("../node-visitor/sandbox");
class TwingExtensionSandbox extends extension_1.TwingExtension {
    constructor(policy, sandboxed = false) {
        super();
        this.policy = policy;
        this.sandboxedGlobally = sandboxed;
    }
    getTokenParsers() {
        return [
            new sandbox_1.TwingTokenParserSandbox()
        ];
    }
    getNodeVisitors() {
        return [
            new sandbox_2.TwingNodeVisitorSandbox()
        ];
    }
    enableSandbox() {
        this.sandboxed = true;
    }
    disableSandbox() {
        this.sandboxed = false;
    }
    isSandboxed() {
        return this.sandboxedGlobally || this.sandboxed;
    }
    isSandboxedGlobally() {
        return this.sandboxedGlobally;
    }
    setSecurityPolicy(policy) {
        this.policy = policy;
    }
    getSecurityPolicy() {
        return this.policy;
    }
    checkSecurity(tags, filters, functions) {
        if (this.isSandboxed()) {
            this.policy.checkSecurity(tags, filters, functions);
        }
    }
    checkMethodAllowed(obj, method) {
        if (this.isSandboxed()) {
            this.policy.checkMethodAllowed(obj, method);
        }
    }
    checkPropertyAllowed(obj, method) {
        if (this.isSandboxed()) {
            this.policy.checkPropertyAllowed(obj, method);
        }
    }
    ensureToStringAllowed(obj) {
        if (this.isSandboxed() && typeof obj === 'object') {
            this.policy.checkMethodAllowed(obj, 'toString');
        }
        return obj;
    }
}
exports.TwingExtensionSandbox = TwingExtensionSandbox;
